import React, { useState, useEffect, useContext } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
} from "@mui/material";

import { TextInput } from "../../../Components/Input/Input";
import { ButtonSave, ButtonClose } from "../../../Components/Button/Button";
import axios from "axios";
import { UrlApi, authorization } from "../../../UrlApi/UrlApi";
import Loading from "../../../Components/Loading/Loading";
import {
  AlertError,
  AlertSuccess,
  AlertWarning,
} from "../../../Components/AlertDialog/AlertDialog";
import SelectAutoComplete from "../../../Components/Input/Input";
import Box from "@mui/material/Box";
import { userData } from "../../../DataContext/DataContext";
import { useRecoilValue } from "recoil";
import FormGroup from "@mui/material/FormGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import Switch from "@mui/material/Switch";

function AddEmailData(props) {
  const user = useRecoilValue(userData);
  const [loading, setLoading] = useState(false);
  const [emailErr, setEmailErr] = useState(false);
 
  const [email, setEmail] = useState("");
  const [statusActive, setStatusActive] = useState(false);

  const onSubmit = async (event) => {
    event.preventDefault();
    if (!isValidEmail(email)) {
      setEmailErr(true);
      return false;
    } else {
      setEmailErr(false);
    }

    const body = {
      email,
      statusActive,
      emailSendFileId: props.emailSendFileId,
    };

      setLoading(true);
      await axios
        .post(UrlApi + "save_email_data", body, authorization)
        .then((res) => {
          if (res.data.status === 1) {
            props.onCancel();
            AlertSuccess(res.data.message);
            setLoading(false);
          } else {
            props.onCancel();
            AlertWarning(res.data.message);
            setLoading(false);
          }
        })
        .catch((err) => {
          setLoading(false);
          AlertError(err);
        });
  };

  const getData = async () => {
    if (props.emailSendFileId !== null) {
      setLoading(true);
      await axios
        .get(
          UrlApi + `get_email_data_for_edit?email_send_file_id=${props.emailSendFileId}`,
          authorization
        )
        .then((res) => {
          setEmail(res.data[0].master_email_send_file);
          setStatusActive(res.data[0].master_email_send_file_active);
          setLoading(false);
        })
        .catch((err) => {
          setLoading(false);
          AlertError(err);
        });
    }

  };

  function isValidEmail(email) {
    return /@uob\.co.th$/.test(email);
  }

  const marginLeft = {
    marginLeft: "9px",
  };

  // const handleEnter = (event) => {
  //   const id = parseInt(event.target.id);
  //   const form = event.target.form;
  //   const index = [...form].indexOf(event.target);
  //   let next = 2;
  //   if (event.key === "Enter") {
  //     if (id === 10) {
  //       onSubmit(event);
  //       return false;
  //     }
  //     switch (id) {
  //       case 2:
  //         next = 3;
  //         break;
  //       case 3:
  //         next = 3;
  //         break;
  //       case 5:
  //         next = 4;
  //         break;     
  //       default:
  //         next = 2;
  //     }
  //     form.elements[index + next].focus();
  //     event.preventDefault();
  //   }
  // };

  useEffect(() => {
    getData();
  }, []);
  return (
    <>
      <Dialog
        open={props.open}
        maxWidth="1500"
        PaperProps={{ style: { borderRadius: 10, width: '600px'}}}
      >
        <Box component="form" noValidate onSubmit={onSubmit} sx={{ mt: 1 }}>
          <DialogTitle>
            <label>
              {props.emailSendFileId === null
                ? "เพิ่ม Email"
                : "แก้ไข Email"}
            </label>
          </DialogTitle>
          <DialogContent dividers="paper">
            <form>
              <table style={{width: '100%'}}>
                <tr>
                  <td colspan="5">
                    <label style={marginLeft}>Email</label>
                    {
                      <TextInput
                        autoFocus={true}
                        id="1"
                        value={email}
                        onChange={(e) => {
                          setEmail(e.target.value);
                          if (!isValidEmail(e.target.value) === true) {
                            setEmailErr(false);
                          }
                        }}
                        error={emailErr}
                        helperText={emailErr && "รูปแบบ Email ต้องเป็น @uob.co.th เท่านั้น"}
                        // onKeyDown={handleEnter}
                        width="100%"
                      />
                    }
                  </td>
                  
                </tr>
                <tr>
                  <td colspan="5">
                    <label style={marginLeft}>สถานะการใช้งาน</label>
                    {
                      <FormGroup style={{ marginLeft: "10px" }}>
                        <FormControlLabel
                          control={
                            <Switch
                              checked={statusActive}
                              onChange={() => {
                                setStatusActive(!statusActive);
                              }}
                            />
                          }
                          label={
                            statusActive ? (
                              <label>เปิดการใช้งาน</label>
                            ) : (
                              <label>ปิดการใช้งาน</label>
                            )
                          }
                        />
                      </FormGroup>
                    }
                  </td>
                </tr>
              </table>
            </form>
          </DialogContent>
          <DialogActions>
            <ButtonSave type="submit" />
            <ButtonClose onClick={() => props.onCancel()} />
          </DialogActions>
          <Loading open={loading} />
        </Box>
      </Dialog>
    </>
  );
}

export default AddEmailData;
